export default __webpack_public_path__ + "static/media/playlistSvg.6caf180b.svg";